import React from 'react';
import { Container, Media } from '../../components';
import { BenefitsAndPerksMobile } from './mobile';
import { BenefitsAndPerksTablet } from './tablet';
import { BenefitsAndPerksDesktop } from './desktop';
import styled from 'styled-components';

const DesktopWrapper = styled.div`
  background-color: #f3f6f6;
`;

export const BenefitsAndPerks = React.forwardRef<any>((props, ref) => {
  return (
    <section ref={ref}>
      <Container>
        <Media at="sm">
          <BenefitsAndPerksMobile />
        </Media>
      </Container>
      <Container>
        <Media at="md">
          <BenefitsAndPerksTablet />
        </Media>
      </Container>
      <DesktopWrapper>
        <Container>
          <Media greaterThanOrEqual="xmd">
            <BenefitsAndPerksDesktop />
          </Media>
        </Container>
      </DesktopWrapper>
    </section>
  );
});
